import { useCallback } from "react";
import type { IContactInfo as ContactInfoFormContext } from "@b2bportal/core-types";
import {
  type ContactEvents,
  ContactEventType,
  ContactSelectors,
  useCheckoutState,
  useCheckoutStateSelector,
} from "@hopper-b2b/checkout";
import type { UseContactInformationFormParams } from "./useContactInformationForm";

type UseContactInfoReturn = UseContactInformationFormParams;

export const useContactInfo = (): UseContactInfoReturn => {
  const [, send] = useCheckoutState();

  const initialContactInfo = useCheckoutStateSelector(
    ContactSelectors.getContactInformation
  );

  const onContactInfoChange = useCallback(
    (newContactInfo: ContactInfoFormContext) =>
      send({
        type: ContactEventType.CHANGE,
        contactInfo: newContactInfo,
      } as ContactEvents),
    [send]
  );

  return {
    initialContactInfo,
    onChange: onContactInfoChange,
  };
};
